<template>
  <component
    :is="component"
    :id="hash"
    :class="[
      className,
      hub?.font_heading_bold ? (level === 1 ? 'font-bold' : 'font-semibold') : null,
      hub?.font_heading_uppercase && level === 1 ? 'uppercase' : null,
      $helpers.textColor(color)
    ]">
    <slot />
  </component>
</template>

<script>
import { mapState } from 'pinia'
import { useSystemStore } from '@/stores/system'
import Str from 'laravel-js-str'

export default {
  props: {
    level: {
      type: Number,
      default: 2
    },
    override: {
      type: String,
      default: null
    },
    color: {
      type: [String, null],
      default: null
    }
  },
  computed: {
    ...mapState(useSystemStore, ['hub']),
    component() {
      return `h${this.level}`
    },
    className() {
      if (this.override) {
        return this.override
      }

      if (this.level === 1) {
        return `font-heading text-2xl ${this.hub?.font_heading_size}`
      }
      if (this.level === 2) {
        return 'font-heading text-xl sm:text-2xl'
      }
      if (this.level === 3) {
        return 'text-lg'
      }
      return ''
    },
    hash() {
      const defaultSlot = this.$slots.default?.()
      const text = defaultSlot ? this.extractText(defaultSlot) : null

      return text ? Str.kebab(text) : null
    }
  },
  methods: {
    extractText(vnodes) {
      let text = ''

      vnodes?.forEach((vnode) => {
        if (typeof vnode.children === 'string') {
          text += vnode.children
        } else if (Array.isArray(vnode.children)) {
          text += this.extractText(vnode.children)
        }
      })

      return text
    }
  }
}
</script>
